var _style, _g, _g2, _g3, _g4, _g5, _g6, _path, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2093653CheckChecklistListMarkOkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{display:inline;fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n\t.st3{display:inline;fill:none;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{display:inline;fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st6{display:inline;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st7{display:none;fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "\\u043F\\u043E\\u0438\\u0441\\u043A"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,8.2c6.2,0,11.3,5.1,11.3,11.3s-5.1,11.3-11.3,11.3S8.2,25.8,8.2,19.5S13.2,8.2,19.5,8.2 M19.5,5.2     c-7.9,0-14.3,6.4-14.3,14.3s6.4,14.3,14.3,14.3s14.3-6.4,14.3-14.3S27.3,5.2,19.5,5.2L19.5,5.2z"
  }))), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 28.8,
    x2: 32.1,
    y1: 28.7,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 44.8,
    x2: 33,
    y1: 44.8,
    y2: 33
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "\\u0430\\u043A\\u0442\\u0438\\u0432\\u044B"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.3,13.9H3.7c-0.3,0-0.5-0.2-0.5-0.5V6.6c0-0.6,0.4-1,1-1h41.7c0.6,0,1,0.4,1,1v6.8   C46.8,13.7,46.6,13.9,46.3,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.5,44.4H7.5c-0.6,0-1-0.4-1-1V13.9h37.1v29.5C43.5,43.9,43.1,44.4,42.5,44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M32.3,26.5H18.2c-1.6,0-2.9-1.3-2.9-2.9v0c0-1.6,1.3-2.9,2.9-2.9h14.1c1.6,0,2.9,1.3,2.9,2.9v0   C35.2,25.1,33.9,26.5,32.3,26.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "\\u0437\\u0430\\u044F\\u0432\\u043A\\u0438"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M11.6,41.3h-3c-0.6,0-1-0.4-1-1v-32c0-0.6,0.4-1,1-1h3V41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M32.2,6.1H12.6c-0.6,0-1,0.4-1,1v35.8c0,0.6,0.4,1,1,1h28.9c0.6,0,1-0.4,1-1V15c0-0.3-0.1-0.6-0.4-0.8   l-9.2-7.8C32.7,6.2,32.4,6.1,32.2,6.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 32.2,
    x2: 32.2,
    y1: 6.1,
    y2: 14.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 42.4,
    x2: 32.2,
    y1: 15,
    y2: 15
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 19,
    x2: 36,
    y1: 20.9,
    y2: 20.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 19,
    x2: 33.3,
    y1: 26,
    y2: 26
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 19,
    x2: 36,
    y1: 30.9,
    y2: 30.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 19,
    x2: 33.3,
    y1: 35.6,
    y2: 35.6
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "\\u0440\\u0435\\u0433\\u0438\\u0441\\u0442\\u0440\\u0430\\u0446\\u0438\\u044F"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.5,32.6v10.7c0,0.6-0.4,1-0.9,1H9.3c-0.5,0-0.9-0.4-0.9-1V6.6c0-0.6,0.4-1,0.9-1h28.3c0.5,0,0.9,0.4,0.9,1   v10.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M28.5,30V20c0-0.2-0.3-0.4-0.5-0.2l-6.6,5c-0.2,0.1-0.2,0.4,0,0.5l6.6,5C28.3,30.4,28.5,30.2,28.5,30z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 28.5,
    x2: 45.6,
    y1: 25,
    y2: 25
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "\\u043E\\u043F\\u043E\\u0432\\u0435\\u0449\\u0435\\u043D\\u0438\\u0435"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.9,16.1h31.3v-4.6c0-0.6-0.4-1-1-1H4.4c-0.6,0-1,0.4-1,1v23.2c0,0.6,0.4,1,1,1h4.6V17.1   C8.9,16.5,9.4,16.1,9.9,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46,42.8H9.9c-0.6,0-1-0.4-1-1V17.1c0-0.6,0.4-1,1-1H46c0.6,0,1,0.4,1,1v24.7C47,42.4,46.6,42.8,46,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46,42.8H9.9c-0.6,0-1-0.4-1-1V17.1c0-0.6,0.4-1,1-1l15.3,14.6c1.5,1.5,4,1.5,5.5,0L46,16.1c0.6,0,1,0.4,1,1   v24.7C47,42.4,46.6,42.8,46,42.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 22.3,
    x2: 8.9,
    y1: 27.9,
    y2: 38.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 33.6,
    x2: 47,
    y1: 28.1,
    y2: 38.9
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "\\u0441\\u0438\\u043D\\u0445\\u0440\\u043E\\u043D\\u0438\\u0437\\u0430\\u0446\\u0438\\u044F"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M30.8,36.6l5.8,8.1c0.1,0.2,0.5,0.2,0.5-0.1l2.5-7.9c0.1-0.2-0.1-0.4-0.3-0.4L31,36.1   C30.8,36.1,30.7,36.4,30.8,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M18.7,12.6l-5.8-8.1c-0.1-0.2-0.5-0.2-0.5,0.1l-2.5,7.9c-0.1,0.2,0.1,0.4,0.3,0.4l8.3,0.2   C18.7,13.1,18.9,12.8,18.7,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39.4,36.5c-3.5,4.3-8.7,7-14.6,7c-10.4,0-18.8-8.4-18.8-18.8c0-1.5,0.2-2.9,0.5-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.1,12.6c3.5-4.3,8.7-7,14.6-7c10.4,0,18.8,8.4,18.8,18.8c0,1.5-0.2,2.9-0.5,4.3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M25.1,5.3c-11.5,0-20.9,8.1-20.9,18.2c0,5.8,3.1,11,8,14.3L7.5,45  c-0.2,0.2,0.1,0.5,0.3,0.4c4.7-0.6,8.9-2,12.5-4.3c1.5,0.3,3.1,0.5,4.8,0.5c11.5,0,20.9-8.1,20.9-18.2S36.7,5.3,25.1,5.3z",
    id: "\\u0432\\u0437\\u0430\\u0438\\u043C\\u043E\\u0434\\u0435\\u0439\\u0441\\u0442\\u0432\\u0438\\u0435"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SLA"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M43.4,44.4H6.6c-0.6,0-1-0.4-1-1V6.6c0-0.6,0.4-1,1-1h36.8c0.6,0,1,0.4,1,1v36.8   C44.4,43.9,43.9,44.4,43.4,44.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 11.9,
    x2: 24.4,
    y1: 36.2,
    y2: 36.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 30.7,
    x2: 33.2,
    y1: 34.8,
    y2: 37.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 38.1,
    x2: 33.2,
    y1: 32.5,
    y2: 37.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 11.9,
    x2: 24.4,
    y1: 26.2,
    y2: 26.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 30.7,
    x2: 33.2,
    y1: 24.8,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 38.1,
    x2: 33.2,
    y1: 22.5,
    y2: 27.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 11.9,
    x2: 24.4,
    y1: 16.2,
    y2: 16.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 30.7,
    x2: 33.2,
    y1: 14.8,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 38.1,
    x2: 33.2,
    y1: 12.5,
    y2: 17.5
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "\\u043E\\u0442\\u0447\\u0435\\u0442"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M44.2,9.3H5.7c-0.6,0-1-0.4-1-1V4.9c0-0.6,0.4-1,1-1h38.5c0.6,0,1,0.4,1,1v3.4C45.2,8.9,44.7,9.3,44.2,9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.2,38.4H7.7c-0.6,0-1-0.4-1-1V9.3h36.5v28.1C43.2,38,42.7,38.4,42.2,38.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 25,
    x2: 25,
    y1: 42.8,
    y2: 38.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 25,
    cy: 45.6,
    r: 2.2
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 28,
    x2: 38.7,
    y1: 18.8,
    y2: 18.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 28,
    x2: 38.7,
    y1: 23.9,
    y2: 23.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 28,
    x2: 38.7,
    y1: 29,
    y2: 29
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M17.8,23.4l-0.6-5.2c0-0.2-0.1-0.3-0.3-0.3c-3.5,0.2-6.2,3.5-5.4,7.1c0.5,2.2,2.3,4,4.5,4.5    c3.7,0.8,6.9-1.9,7.1-5.3c0-0.2-0.1-0.3-0.3-0.3L17.8,23.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2093653CheckChecklistListMarkOkIcon);
export default __webpack_public_path__ + "static/media/2093653_check_checklist_list_mark_ok_icon.aef82d1e49dd832c270855b994532af1.svg";
export { ForwardRef as ReactComponent };